import { productAPI } from '../api/product';
import { actionWrapper } from './actionWrapper';
import { objectToFormData } from '../utils/functions';

export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_PRODUCT_CATEGORIES = 'SET_PRODUCT_CATEGORIES';
export const SET_DISLIKED_PRODUCTS = 'SET_DISLIKED_PRODUCTS';
export const SET_SUGGESTED_PRODUCTS = 'SET_SUGGESTED_PRODUCTS';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';

export const getProducts = () => actionWrapper(async () => {
  const productsData = await productAPI.getProducts();

  return {
    type: SET_PRODUCTS,
    payload: productsData,
  };
});

export const getProductCategories = () => actionWrapper(async () => {
  const categoriesData = await productAPI.getProductCategories();

  return {
    type: SET_PRODUCT_CATEGORIES,
    payload: categoriesData,
  };
});

export const addProduct = (productData, callback) => actionWrapper(async (dispatch) => {
  const formData = objectToFormData(productData);
  await productAPI.addProduct(formData);
  callback?.();
  dispatch(getProducts());
});

export const updateProduct = (productData, callback) => actionWrapper(async (dispatch) => {
  const formData = objectToFormData(productData);
  await productAPI.updateProduct(formData);
  callback?.();
  dispatch(getProducts());
});

export const deleteProduct = (id) => actionWrapper(async () => {
  await productAPI.deleteProduct(id);

  return {
    type: DELETE_PRODUCT,
    payload: id,
  };
});

export const getDislikedProducts = () => actionWrapper(async () => {
  const dislikedProductsData = await productAPI.getDislikedProducts();

  return {
    type: SET_DISLIKED_PRODUCTS,
    payload: dislikedProductsData,
  };
});

export const addDislikedProduct = (productData) => actionWrapper(async (dispatch) => {
  await productAPI.addDislikedProduct(productData);
  dispatch(getDislikedProducts());
});

export const updateDislikedProduct = (productData) => actionWrapper(async (dispatch) => {
  await productAPI.updateDislikedProduct(productData);
  dispatch(getDislikedProducts());
});

export const deleteDislikedProduct = (id) => actionWrapper(async (dispatch) => {
  await productAPI.deleteDislikedProduct(id);
  dispatch(getDislikedProducts());
});

export const findDislikedProductsIngredients = (productId) => actionWrapper(async () => {
  await productAPI.findDislikedProductsIngredients(productId);
  return getDislikedProducts();
});

export const addDislikedProductIngredient = (ingredientData, callback) => actionWrapper(async (dispatch) =>{
  await productAPI.addDislikedProductIngredient(ingredientData);
  dispatch(getDislikedProducts());
  callback?.();
});

export const deleteDislikedProductIngredient = (ingredientData, callback) => actionWrapper(async (dispatch) =>{
  await productAPI.deleteDislikedProductIngredient(ingredientData);
  dispatch(getDislikedProducts());
  callback?.();
});

export const getSuggestedProducts = () => actionWrapper(async () => {
  const suggestedProductsData = await productAPI.getSuggestedProducts();

  return {
    type: SET_SUGGESTED_PRODUCTS,
    payload: suggestedProductsData,
  };
});

export const addSuggestedProduct = (productData, callback) => actionWrapper(async (dispatch) => {
  const formData = objectToFormData(productData);
  await productAPI.addSuggestedProduct(formData);
  callback?.();
  dispatch(getSuggestedProducts());
});

export const updateSuggestedProduct = (productData, callback) => actionWrapper(async (dispatch) => {
  const formData = objectToFormData(productData);
  await productAPI.updateSuggestedProduct(formData);
  callback?.();
  dispatch(getSuggestedProducts());
});

export const deleteSuggestedProduct = (id) => actionWrapper(async (dispatch) => {
  await productAPI.deleteSuggestedProduct(id);
  dispatch(getSuggestedProducts());
});